import React from "react";
import PropTypes from "prop-types";

// import { Link } from "gatsby";

import "./CaseStudyTemplate.scss";
import styles from "./CaseStudyTemplate.module.scss";

import Back from "../../img/back.svg";

import Image from "./Blocks/Image";
import Video from "./Blocks/Video";
import Text from "./Blocks/Text";
import Carousel from "./Blocks/Carousel";
import Space from "./Blocks/Space";

import ProgressScroll from "./ProgressScroll";
import NextCaseStudy from "./NextCaseStudy";

const CaseStudyTemplate = ({
  description,
  roles,
  headline,
  name,
  helmet,
  blocks,
  progressColor,
  gradientColor,
  nextCaseStudy,
}) => {
  function blockFactory(block) {
    const type = block.__typename;

    if (type === "ContentfulContentBlockImage") {
      return <Image image={block.image} imageMobile={block.imageMobile} />;
    }
    if (type === "ContentfulContentBlockVideo")
      return (
        <Video
          url={block.video.file.url}
          urlMobile={block.videoMobile && block.videoMobile.file.url}
        />
      );
    if (type === "ContentfulContentBlockCarousel")
      return <Carousel images={block.images} />;

    if (type === "ContentfulContentBlockEmptySpace")
      return (
        <Space
          mobile={block.mobileSpaceInPixels}
          desktop={block.desktopSpaceInPixels}
        />
      );

    if (type === "ContentfulContentBlockText")
      return (
        <Text
          category={
            block.categoryGradient && block.categoryGradient.categoryGradient
          }
          title={block.title && block.title.title}
          paragraph={block.paragraph && block.paragraph.paragraph}
          gradientColor={gradientColor}
        />
      );

    return <div>Unknown Block</div>;
  }

  function goBack() {
    window.history.back();
  }

  return (
    <section className="is-marginless is-paddingless">
      {helmet || ""}
      <ProgressScroll color={progressColor} />
      <div className={styles.caseStudy}>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            {/* <Link className={styles.navigateBack} to="/case-studies">
              <Back />
            </Link> */}
            <div
              className={styles.navigateBack}
              onClick={goBack}
              onKeyPress={goBack}
              role="button"
              tabIndex={0}
            >
              <Back />
            </div>
            <div className={styles.name}>{name}</div>
            <h1 className={styles.title}>{headline}</h1>
            <div className={styles.descriptionContainer}>
              <p className={styles.description}>{description}</p>
              <div className={styles.role}>
                <ul>
                  {roles.map((r) => (
                    <li key={r}>{r}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        {blocks &&
          blocks.map((block, index) => (
            <React.Fragment key={index}>{blockFactory(block)}</React.Fragment>
          ))}
      </div>
      <NextCaseStudy
        title={nextCaseStudy.title}
        name={nextCaseStudy.name}
        shortDescription={nextCaseStudy.shortDescription}
        path={`/case-studies/${nextCaseStudy.path}`}
        featuredImage={nextCaseStudy.featuredImage}
      />
    </section>
  );
};

CaseStudyTemplate.propTypes = {
  helmet: PropTypes.object.isRequired,
  headline: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  roles: PropTypes.array.isRequired,
  progressColor: PropTypes.string.isRequired,
  gradientColor: PropTypes.object.isRequired,
  blocks: PropTypes.array.isRequired,
  nextCaseStudy: PropTypes.object.isRequired,
};

export default CaseStudyTemplate;
